import Base from "./Base"
import request from "../services/request"
import { flattenTree } from "../services/utils"

class Organization extends Base {
  all(clientIds) {
    return this.promise().then(table => {
      if (clientIds) {
        return table.where("client_id").anyOf(clientIds).toArray()
      }
      return table.toArray()
    })
  }

  tree() {
    return this.promise().then(table => {
      return table.where({ parent_id: "" }).toArray()
    })
  }

  // leaves() {
  //  return this.promise().then(table => {
  //    return table.where({ isLeaf: 1 }).toArray()
  //  })
  // }

  // groups() {
  //  return this.promise().then(table => {
  //    return table.where({ kind: "groups" }).toArray()
  //  })
  // }

  // sofac() {
  //  return this.promise().then(table => {
  //    return table.where({ kind: "sofac" }).toArray()
  //  })
  // }

  // establishments() {
  //  return this.promise().then(table => {
  //    return table.where({ kind: "establishment" }).toArray()
  //  })
  // }

  async fetch() {
    const response = await request.get("/api/v4/organizations")
    const organizations = Array.isArray(response) ? response : response.organizations

    return flattenTree(organizations, (organization, parent) => {
      organization.parent_id = parent && parent.client_id || ""
      organization.isLeaf = organization.children ? 0 : 1
    })
  }
}

export default new Organization("organizations")
